/**
 * Validate for valid URL
 */
export const isValidURL = (value?: string): string | void =>
  value && !/^\w+.*\.[\S]*[\w|\/]$/.test(value) ? 'global.not_a_valid_url' : undefined
